import { event } from "@zillow/universal-analytics";
const eventTypes = {
  RENT_VS_BUY_VIEW: "rent vs buy view",
  RENT_VS_BUY_INTERACTION: "rent vs buy interaction",
  RENT_AFFORDABILITY_VIEW: "rent affordability view",
  RENT_AFFORDABILITY_INTERACTION: "rent affordability interaction"
};
const rentVsBuyInteractionTypes = {
  HOME_PRICE: "home_price",
  DOWN_PAYMENT: "down_payment",
  MONTHLY_RENT: "monthly_rent",
  HOME_APPRECIATION_RATE: "home_appreciation_rate",
  RENT_APPRECIATION_RATE: "rent_appreciation_rate",
  INVESTMENT_RATE: "investment_rate",
  MORTGAGE_RATE: "mortgage_rate",
  HOA_FEES: "hoa_fees",
  PROPERTY_TAX_RATE: "property_tax_rate",
  MAINTENANCE_RATE: "maintenance_rate",
  PURCHASE_COSTS_PERCENT: "purchase_cost_percent",
  SELLING_COSTS_PERCENT: "selling_cost_percent",
  HOMEOWNERS_INSURANCE_COST: "homeowners_insurance_cost",
  MARGINAL_TAX_RATE: "marginal_tax_rate",
  ANNUAL_RENOVATION_COSTS: "annual_renovation_costs",
  RENTING_UTILITY_COSTS: "renting_utility_costs",
  RENT_BROKER_FEE: "rent_broker_fee",
  RENTERS_INSURANCE_COST: "renters_insurance_cost"
};
const clickstreamProperties = {
  envelope: {
    event_template_id: "91",
    event_template_version_id: "1",
    event_type_version_id: "1",
    event_type_id: ""
  },
  clickstream_trigger: {
    trigger_location_nm: "",
    trigger_type_nm: "",
    trigger_object_nm: "",
    trigger_source_nm: ""
  },
  semantic: {
    topic_tag_txt: ["calculator"],
    semantic_event_nm: ""
  },
  calc_block: {
    title_txt: "",
    displayed_fields: [],
    interaction_button_txt: ""
  }
};
function updateEnvelope(eventType) {
  const envelopeBlock = {
    ...clickstreamProperties.envelope
  };
  if (eventType === eventTypes.RENT_VS_BUY_VIEW) {
    envelopeBlock.event_type_id = "480";
  } else if (eventType === eventTypes.RENT_VS_BUY_INTERACTION) {
    envelopeBlock.event_type_id = "481";
  } else if (eventType === eventTypes.RENT_AFFORDABILITY_VIEW) {
    envelopeBlock.event_type_id = "482";
  } else if (eventType === eventTypes.RENT_AFFORDABILITY_INTERACTION) {
    envelopeBlock.event_type_id = "483";
  }
  return envelopeBlock;
}
function updateClickstreamTrigger(eventType) {
  const triggerBlock = {
    ...clickstreamProperties.clickstream_trigger
  };
  if (eventType === eventTypes.RENT_VS_BUY_VIEW) {
    triggerBlock.trigger_location_nm = "rent_v_buy_calculator_page";
    triggerBlock.trigger_type_nm = "view";
    triggerBlock.trigger_object_nm = "no_trigger_object";
    triggerBlock.trigger_source_nm = "rent_v_buy_calculator_page";
  } else if (eventType === eventTypes.RENT_VS_BUY_INTERACTION) {
    triggerBlock.trigger_location_nm = "rent_v_buy_calculator_page";
    triggerBlock.trigger_type_nm = "interaction";
    triggerBlock.trigger_object_nm = "rent_v_buy_calculator_object";
    triggerBlock.trigger_source_nm = "calculator_interaction_button";
  } else if (eventType === eventTypes.RENT_AFFORDABILITY_VIEW) {
    triggerBlock.trigger_location_nm = "rent_affordability_calculator_page";
    triggerBlock.trigger_type_nm = "view";
    triggerBlock.trigger_object_nm = "no_trigger_object";
    triggerBlock.trigger_source_nm = "rent_affordability_calculator_page";
  } else if (eventType === eventTypes.RENT_AFFORDABILITY_INTERACTION) {
    triggerBlock.trigger_location_nm = "rent_affordability_calculator_page";
    triggerBlock.trigger_type_nm = "interaction";
    triggerBlock.trigger_object_nm = "rental_affordability_object";
    triggerBlock.trigger_source_nm = "calculator_interaction_button";
  }
  return triggerBlock;
}
function updateSemantic(eventType) {
  const semanticBlock = {
    ...clickstreamProperties.semantic
  };
  if (eventType === eventTypes.RENT_VS_BUY_VIEW) {
    semanticBlock.semantic_event_nm = "view_content";
  } else if (eventType === eventTypes.RENT_VS_BUY_INTERACTION) {
    semanticBlock.semantic_event_nm = "rent_v_buy_calculator_interaction";
  } else if (eventType === eventTypes.RENT_AFFORDABILITY_VIEW) {
    semanticBlock.semantic_event_nm = "view_content";
  } else if (eventType === eventTypes.RENT_AFFORDABILITY_INTERACTION) {
    semanticBlock.semantic_event_nm = "rent_affordability_calculator_interaction";
  }
  return semanticBlock;
}
function updateCalculatorBlock(eventType, interactionType, displayedFields = []) {
  const calcBlock = {
    ...clickstreamProperties.calc_block
  };
  if (eventType === eventTypes.RENT_VS_BUY_VIEW || eventType === eventTypes.RENT_VS_BUY_INTERACTION) {
    calcBlock.title_txt = "rent_v_buy_calculator";
  } else if (eventType === eventTypes.RENT_AFFORDABILITY_VIEW || eventType === eventTypes.RENT_AFFORDABILITY_INTERACTION) {
    calcBlock.title_txt = "rent_affordability_calculator";
  }
  calcBlock.displayed_fields = displayedFields;
  calcBlock.interaction_button_txt = interactionType || "";
  return calcBlock;
}
function getClickstreamProperties(eventType, interactionType, displayedFields = []) {
  return {
    envelope: updateEnvelope(eventType),
    clickstream_trigger: updateClickstreamTrigger(eventType),
    semantic: updateSemantic(eventType),
    calc_block: updateCalculatorBlock(eventType, interactionType, displayedFields)
  };
}
function handleRentVsBuyClickstreamEvent(eventType, interactionType, displayedFields = []) {
  const payload = getClickstreamProperties(eventType, interactionType, displayedFields);
  event(payload);
}
export {
  eventTypes,
  handleRentVsBuyClickstreamEvent,
  rentVsBuyInteractionTypes
};
